// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import enhanceWithClickOutside from "react-click-outside";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { Dropdown, LocaleLink, Button, Icon } from "../../common";
import disputeRTV from "../../../images/common/disputeRTV1.svg";
import disputeTransfers from "../../../images/common/disputeTransfers1.svg";
import styles from "../../transfers/createTransfers/CreateTransfers.scss";

class CreateDisputes extends Component {
  state = {
    selected: 1,
    inputSearch: "",
    reason: "",
    showResult: true,
    description: ""
  };

  componentDidMount() {
    window.addEventListener(
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        ? "touchstart"
        : "click",
      this.handleClickOutside,
      true
    );
    this.props.searchDisputeAsnRtv(
      this.state.selected === 2 ? "RETURN" : "TRANSFER"
    );
    //this.props.listDisputeReasons(this.state.selected === 2 ? "ASN_XD" : "RTV");
    this.props.listDisputeReasons(this.state.selected === 2 ? "RTV" : "ASN_XD");
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      !this.props.isCreating &&
      prevProps.isCreating &&
      this.props.disputeNr &&
      this.props.disputeNr.ticket_nr
    ) {
      this.props.history.push(
        `/${Helper.getLocale()}/disputes/ticket/${this.props.disputeNr.ticket_nr}`
      );
    }
    if (this.state.selected !== prevState.selected) {
      this.props.searchDisputeAsnRtv(
        this.state.selected === 2 ? "RETURN" : "TRANSFER"
      );
      this.props.listDisputeReasons(
        //this.state.selected === 2 ? "ASN_XD" : "RTV"
        this.state.selected === 2 ? "RTV" : "ASN_XD"
      );
    }
  };

  componentWillUnmount() {
    window.removeEventListener(
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        ? "touchstart"
        : "click",
      this.handleClickOutside,
      true
    );
  }

  inputChange = e => {
    const newState = this.state;
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  };
  dropdownChange(e, key) {
    var newState = this.state;
    newState[`${key}`] = e.value;
    this.setState(newState);
  }

  onSubmit = () => {
    const payload = {
      ref: this.state.inputSearch,
      description: this.state.description,
      dispute_type: this.state.selected === 2 ? "RETURN" : "TRANSFER",
      id_dispute_reason: this.state.reason
    };
    this.props.createDispute(payload);
  };

  switchType = selected => {
    this.setState({
      selected,
      inputSearch: "",
      reason: ""
    });
  };

  blurInput = () => {
    this.setState({
      showResult: false
    });
  };

  selectInput = result => {
    const newState = this.state;
    newState.inputSearch = result;
    newState.showResult = false;
    this.setState(newState);
  };

  handleClickOutside = e => {
    if (
      this.state.showResult &&
      this.sidePanel &&
      !this.sidePanel.contains(e.target)
    ) {
      this.setState({ showResult: false });
    }
  };

  render() {
    const { searchResult, isCreating, isListing, disputeReasons } = this.props;

    const { selected, inputSearch, description, reason } = this.state;

    const docOptions = [];
    if (searchResult && searchResult) {
      for (let i = 0; i < searchResult.length; i++) {
        docOptions.push({
          value: searchResult[i],
          label: searchResult[i]
        });
      }
    }
    const reasonsOptions = [];
    if (disputeReasons) {
      for (let i = 0; i < disputeReasons.length; i++) {
        reasonsOptions.push({
          value: disputeReasons[i].id_dispute_reason,
          label: disputeReasons[i].name
        });
      }
    }

    return (
      <div className={styles.ctr}>
        <div className={styles.disputeType}>
          <a
            className={`${styles.eachType} ${
              selected === 1 ? styles.selected : ""
            }`}
            onClick={() => this.switchType(1)}
          >
            <img src={disputeTransfers} alt="disputeTransfers" />
            <div className={styles.disputeTypeTitle}>
              {I18n.getText("menu.transfers")}
            </div>
          </a>
          <a
            className={`${styles.eachType} ${
              selected === 2 ? styles.selected : ""
            }`}
            onClick={() => this.switchType(2)}
          >
            <img src={disputeRTV} alt="disputeRTV" />
            <div className={styles.disputeTypeTitle}>
              {I18n.getText("disputes.rtv")}
            </div>
          </a>
        </div>
        <div className={styles.inputCtr}>
          <div className={styles.inputWrapper}>
            <label>
              {I18n.getText(
                selected === 2 ? "disputes.rtv-document" : "disputes.closed-asn"
              )}
            </label>
            <div className={styles.input}>
              <div className={styles.dropdownWrapper}>
                {I18n.getComponent(
                  formattedValue => (
                    <Dropdown
                      options={docOptions}
                      height="short"
                      placeholder={formattedValue}
                      searchable
                      value={inputSearch}
                      disabled={searchResult && searchResult.length < 1}
                      onChange={e => this.dropdownChange(e, "inputSearch")}
                    />
                  ),
                  searchResult && searchResult.length < 1
                    ? selected === 1 ? "disputes.no-asn" : "disputes.no-rtv"
                    : "dropdown.select"
                )}
              </div>
            </div>
          </div>
          <div className={styles.inputWrapper}>
            <label>{I18n.getText("disputes.reason")}</label>
            <div className={styles.input}>
              <div className={styles.dropdownWrapper}>
                {I18n.getComponent(
                  formattedValue => (
                    <Dropdown
                      options={reasonsOptions}
                      height="short"
                      placeholder={formattedValue}
                      searchable
                      value={reason}
                      disabled={reasonsOptions && reasonsOptions.length < 1}
                      onChange={e => this.dropdownChange(e, "reason")}
                    />
                  ),
                  reasonsOptions && reasonsOptions.length < 1
                    ? "disputes.no-reasons"
                    : "dropdown.select"
                )}
              </div>
            </div>
          </div>
          <div className={styles.inputWrapper}>
            <label>{I18n.getText("disputes.description")}</label>
            <div className={styles.input}>
              {I18n.getComponent(
                formattedValue => (
                  <textarea
                    rows="4"
                    value={description}
                    name="description"
                    onChange={e => this.inputChange(e)}
                    placeholder={formattedValue}
                  />
                ),
                "disputes.description-placeholder"
              )}
            </div>
          </div>
        </div>
        <div className={styles.btnCtr}>
          <LocaleLink to={`/disputes`}>
            <Button variant="transparent" className={styles.printCtr}>
              {I18n.getText("transfers.cancel")}
            </Button>
          </LocaleLink>

          <Button
            className={styles.printCtr}
            disabled={
              inputSearch === "" ||
              isListing ||
              isCreating ||
              !searchResult ||
              reason === "" ||
              description === ""
            }
            onClick={this.onSubmit}
          >
            {I18n.getText("transfers.confirm")}
          </Button>
        </div>
      </div>
    );
  }
}
export default CreateDisputes;



// WEBPACK FOOTER //
// ./src/components/disputes/createDisputes/CreateDisputes.js